import PromotionCarouselBlock from './PromotionCarouselBlock'
import PromotionCarouselCardBlock from './PromotionCarouselCardBlock'

export { PromotionCarouselBlock, PromotionCarouselCardBlock }
